import React from 'react';
import { useTranslation } from 'react-i18next';
import { HeadlineSmall } from '@shared/ui/atoms/fonts/Headline';
import { AzureScimIntegrationSettingMessage } from '@shared/ui/organisms/settings/AzureScimIntegrationMessage';
import { ScimApiKeysSection, ScimEndpointSection } from './ApiKeysPanel';

interface Props {
  editable: boolean;
}

export function AzureActiveDirectoryPanel({ editable }: Props) {
  const { t } = useTranslation();
  return (
    <>
      <HeadlineSmall style={{ marginBottom: 16 }}>{t('company-settings-page.azure-configuration')}</HeadlineSmall>
      <AzureScimIntegrationSettingMessage style={{}}>
        <ScimEndpointSection />
        {editable && <ScimApiKeysSection />}
      </AzureScimIntegrationSettingMessage>
    </>
  );
}
